/*
 Created by CHT 2019/12/28 15:03
*/

import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__SERIAL_NUMBER,
  FORM_ITEM__PHONE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__SLIDING_BLOCK,
  FORM_ITEM__GRADE,
  FORM_ITEM__YES_NO,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__DATE,
  FORM_ITEM__MEMBER,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__IMAGE,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__CASCADE
} from "../../RyForm/types"

export const FILTER_METHOD_TYPE__EQ = 'eq'            // 等于
export const FILTER_METHOD_TYPE__NE = 'ne'            // 不等于
export const FILTER_METHOD_TYPE__IN = 'in'            // 等于任意一个   包含任意一个
export const FILTER_METHOD_TYPE__NIN = 'nin'          // 不等于任意一个  不属于
export const FILTER_METHOD_TYPE__LIKE = 'like'        // 包含
export const FILTER_METHOD_TYPE__UNLIKE = 'unlike'    // 不包含
export const FILTER_METHOD_TYPE__EMPTY = 'empty'      // 为空
export const FILTER_METHOD_TYPE__NOT_EMPTY = 'not_empty'  // 不为空
export const FILTER_METHOD_TYPE__GT = 'gt'            // 大于
export const FILTER_METHOD_TYPE__GTE = 'gte'          // 大于等于
export const FILTER_METHOD_TYPE__LT = 'lt'            // 小于
export const FILTER_METHOD_TYPE__LTE = 'lte'          // 小于等于
export const FILTER_METHOD_TYPE__RANGE = 'range'      // 选择范围
export const FILTER_METHOD_TYPE__ALL = 'all'          // 同时包含   属于



/**
 * 筛选 的 类型 分组
 * @type {string}
 */
export const FILTER_GROUP__STRING = 'string'
export const FILTER_GROUP__CHECKBOX = 'checkbox'
export const FILTER_GROUP__MEMBER = 'member'
export const FILTER_GROUP__NUMBER = 'number'
export const FILTER_GROUP__JSON = 'json'
export const FILTER_GROUP__LONG = 'long'
export const FILTER_GROUP__ATTACHMENT = 'attachment'

/**
 * 可作为筛选字段的类型分组
 * @type {Object}
 */
export const FILTER_FORM_ITEM__MAP = {
  [FILTER_GROUP__STRING]: [
    FORM_ITEM__SINGLE_LINE,
    FORM_ITEM__MULTILINE,
    FORM_ITEM__SINGLE_CHOOSE,
    FORM_ITEM__DROPDOWN,
    FORM_ITEM__SERIAL_NUMBER,
    FORM_ITEM__PHONE,
    FORM_ITEM__EXTERNAL_DATA_SOURCE,
    FORM_ITEM__CASCADE
  ],
  [FILTER_GROUP__CHECKBOX]: [
    FORM_ITEM__CHECKBOX,
  ],
  [FILTER_GROUP__MEMBER]: [
    FORM_ITEM__MEMBER,
    FORM_ITEM__DEPARTMENT
  ],
  [FILTER_GROUP__NUMBER]: [
    FORM_ITEM__NUMBER,
    FORM_ITEM__CURRENCY,
    FORM_ITEM__SLIDING_BLOCK,
    FORM_ITEM__GRADE,
    FORM_ITEM__YES_NO
  ],
  [FILTER_GROUP__JSON]: [
    FORM_ITEM__ADDRESS
  ],
  [FILTER_GROUP__LONG]: [
    FORM_ITEM__DATE
  ],
  [FILTER_GROUP__ATTACHMENT]: [
    FORM_ITEM__IMAGE,
    FORM_ITEM__ATTACHMENT
  ]
}
/**
 * 可作为筛选字段的列表
 * @type {Array}
 */
export const FILTER_FORM_ITEM__LIST = (() => {
  let list = []
  Object.values(FILTER_FORM_ITEM__MAP).forEach(formItemList => {
    list.push(...formItemList)
  })
  return list
})()
